import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <Container>
          <Row className="justify-content-center mb-3">
            <Col xs="auto">
              <ul className="footer-links">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/explore">Explore</Link>
                </li>
                <li>
                  <Link to="/pricing">Pricing</Link>
                </li>
                <li>
                  <Link to="/terms">Terms of Use</Link>
                </li>
                <li>
                  <Link to="/community">Community</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/coming-soon">Contact</Link>
                </li>
              </ul>
            </Col>
          </Row>

          <Row className="social-icons-wraper">
            <Col xs="auto">
              <div className="social-icons">
                <Link to="#" aria-label="Facebook">
                  <FaFacebookF />
                </Link>
                <Link to="#" aria-label="Twitter">
                  <FaXTwitter />
                </Link>
                <Link to="#" aria-label="YouTube">
                  <AiOutlineYoutube />
                </Link>
                <Link to="#" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
      <div className="footer-btm">
        <p className="text-center">
          &copy; {new Date().getFullYear()} Healthscope AI. All rights
          reserved.
        </p>
      </div>
    </>
  );
};

export default Footer;
